import { FilterLogic, FilterGroup } from '../types';

export const getDefaultFilterGroupObject = (
  group: number,
  logic = FilterLogic.AND,
): FilterGroup => ({
  group,
  logic,
  conditions: [
    {
      field: null,
      operation: null,
      value: undefined,
    },
  ],
});
